exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drag-anchor{cursor:move;cursor:-webkit-grab;cursor:-moz-grab;width:20px;height:30px;padding:5px;background:#fff;color:#ddd;border:1px solid #ddd;border-radius:6px;border-bottom-left-radius:6px}.dragging,.drop-target{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing}", ""]);

// exports
